// Préférences locales de l'appareil (thème, vue Terrain/Expert). Confort uniquement : tout fonctionne sans.
import { useEffect, useState } from 'react';

type Theme = 'systeme' | 'light' | 'dark';
type Vue = 'terrain' | 'expert';

function lire<T extends string>(cle: string, defaut: T): T {
  try { return (localStorage.getItem(cle) as T) || defaut; } catch { return defaut; }
}
function ecrire(cle: string, v: string) {
  try { localStorage.setItem(cle, v); } catch { /* stockage indisponible : préférence non mémorisée */ }
}

export function appliquerPreferences() {
  const t = lire<Theme>('trame.theme', 'systeme');
  if (t === 'systeme') delete document.documentElement.dataset.theme; else document.documentElement.dataset.theme = t;
  document.documentElement.dataset.vue = lire<Vue>('trame.vue', 'expert');
}

function usePreference<T extends string>(cle: string, defaut: T, appliquer: (v: T) => void) {
  const [v, setV] = useState<T>(() => lire(cle, defaut));
  useEffect(() => { appliquer(v); ecrire(cle, v); }, [v]);
  return [v, setV] as const;
}

export const useTheme = () => usePreference<Theme>('trame.theme', 'systeme', (t) => {
  if (t === 'systeme') delete document.documentElement.dataset.theme; else document.documentElement.dataset.theme = t;
});

export const useVue = () => usePreference<Vue>('trame.vue', 'expert', (v) => { document.documentElement.dataset.vue = v; });

export function useEnLigne() {
  const [enLigne, setEnLigne] = useState(navigator.onLine);
  useEffect(() => {
    const on = () => setEnLigne(true); const off = () => setEnLigne(false);
    window.addEventListener('online', on); window.addEventListener('offline', off);
    return () => { window.removeEventListener('online', on); window.removeEventListener('offline', off); };
  }, []);
  return enLigne;
}
